{
  "screen": {
    "overline": "PRÁCTICA GLOBAL",
    "title": "Horario",
    "subtitle": "Sesiones en vivo de maestros y eventos presenciales — retiros, talleres, ceremonias y encuentros comunitarios.",
    "liveStreams": "Sesiones en Vivo",
    "programEvent": {
      "note": "Incluida en un programa que compraste",
      "cta": "En tu programa"
    },
    "eventsTab": "Eventos",
    "loading": "Sincronizando estado en vivo...",
    "noSessions": "No Hay Sesiones Próximas",
    "noSessionsHint": "Vuelve pronto para nuevas sesiones en vivo de nuestros maestros globales.",
    "browseEvents": "Explorar Eventos",
    "streamingNow": "LIVE",
    "upcomingSessions": "Próximas Sesiones",
    "allSessions": "Todas las Sesiones",
    "subscribed": "Suscrito",
    "subscribedCount": "Suscrito ({{count}})",
    "allTraditions": "Todas las Tradiciones",
    "tradition": "TRADICIÓN",
    "tags": "ETIQUETAS",
    "segmentAll": "Todo",
    "segmentAgape": "Agapē",
    "segmentMasters": "Maestros",
    "eventCount": "{{count}} Evento",
    "eventCount_plural": "{{count}} Eventos",
    "live": "EN VIVO",
    "subscribedBtn": "SUSCRITO",
    "notifyMe": "NOTIFICARME",
    "loadingEvents": "Cargando eventos...",
    "noEventsFound": "No Se Encontraron Eventos",
    "noEventsForTradition": "Aún no hay eventos de {{tradition}} programados.",
    "noEventsForTags": "No hay eventos que coincidan con las etiquetas seleccionadas.",
    "noMasterEvents": "Aún no hay eventos de maestros programados.",
    "noAgapeEvents": "Aún no hay eventos de Agapē programados.",
    "noEventsDefault": "Aún no hay eventos programados.",
    "clearFilters": "Limpiar Filtros",
    "tryAgain": "Intentar de Nuevo",
    "calendarDownloaded": "Archivo de calendario descargado",
    "calendarFailed": "Error al descargar el archivo de calendario",
    "reminderSet": "Recordatorio activado",
    "reminderFailed": "Error al activar el recordatorio"
  },
  "filters": {
    "master": "Maestro",
    "specialty": "Especialidad",
    "timeOfDay": "Hora del Día",
    "morning": "Mañana",
    "afternoon": "Tarde",
    "evening": "Noche",
    "night": "Noche (tardía)",
    "allMasters": "Todos los Maestros",
    "allSpecialties": "Todas",
    "clearAll": "Limpiar filtros",
    "noResults": "Ninguna sesión coincide con tus filtros",
    "clearAndRetry": "Limpiar filtros",
    "searchMasters": "Buscar maestros..."
  },
  "detail": {
    "loading": "Conectando a la sesión en vivo...",
    "unavailable": "Sesión en Vivo No Disponible",
    "unavailableHint": "Esta sesión en vivo no se encontró o ya no está disponible.",
    "programLiveGone": "Esta sesión en vivo ya no está en el horario",
    "programLiveGoneHint": "El maestro la canceló o la eliminó. Formaba parte del programa «{{program}}»: allí está el horario actual.",
    "programLiveGoneHintNoTitle": "El maestro la canceló o la eliminó. El horario actual está en la página del programa.",
    "openProgram": "Ir al programa",
    "backToLives": "Volver a los eventos",
    "backToSchedule": "VOLVER AL HORARIO",
    "ended": "La Sesión Ha Terminado",
    "endedHint": "Esta sesión en vivo con {{name}} ha concluido. Una grabación podría estar disponible pronto.",
    "viewMaster": "VER MAESTRO",
    "invite": "Invitar",
    "edit": "Editar",
    "signIn": "Iniciar Sesión",
    "translate": "Traducir",
    "streamingTranslation": "Transmitiendo traducción",
    "chooseLanguage": "Elegir Idioma",
    "searchLanguages": "Buscar idiomas...",
    "noLanguagesMatch": "Ningún idioma coincide con tu búsqueda",
    "noLanguages": "No hay idiomas adicionales disponibles",
    "signUpReserve": "Crea una cuenta para reservar tu lugar",
    "cancelReservation": "¿Cancelar reservación?",
    "cancelReservationHint": "Ya no recibirás recordatorios para esta sesión.",
    "keep": "Mantener",
    "cancelReservationBtn": "Cancelar reservación",
    "signUpReminders": "Regístrate para activar recordatorios de esta sesión",
    "signUpFavorites": "Regístrate para guardar tus sesiones favoritas",
    "inFavorites": "EN FAVORITOS",
    "addToFavorites": "AÑADIR A FAVORITOS",
    "remindMe": "Recordarme",
    "calendar": "Calendario",
    "inboxLink": "Se enviará un enlace directo a tu bandeja de entrada 10 minutos antes de que comience la sesión.",
    "follow": "Seguir",
    "following": "Siguiendo",
    "aboutSession": "Sobre esta sesión"
  },
  "cancelDialog": {
    "title": "¿Cancelar el evento?",
    "message": "«{{title}}» se cancelará. {{notice}} Esta acción no se puede deshacer.",
    "confirm": "Cancelar evento",
    "keep": "No cancelar",
    "done": "Evento eliminado",
    "noticeCircle": "Los suscriptores recibirán un aviso en el chat del Círculo.",
    "noticeProgram": "Quienes compraron el programa recibirán un aviso.",
    "noticeSignedUp": "Quienes se apuntaron recibirán un aviso."
  },
  "status": {
    "streamingNow": "LIVE",
    "startsInDays": "COMIENZA EN {{days}}D {{hours}}H",
    "startsInHours": "COMIENZA EN {{hours}}H {{minutes}}M",
    "startsInMinutes": "COMIENZA EN {{minutes}}M"
  },
  "stream": {
    "connecting": "Conectando a la sesión en vivo...",
    "waitingForHost": "Esperando a que el anfitrión comience la sesión en vivo...",
    "unavailable": "Sesión en vivo no disponible",
    "endConfirm": "¿Estás seguro de que deseas detener la sesión en vivo?",
    "endBroadcast": "Finalizar Sesión en Vivo",
    "endStream": "Finalizar Transmisión",
    "endLiveEvent": "Finalizar Evento en Vivo",
    "endLiveConfirm": "Esto detendrá la sesión en vivo Y finalizará el evento para todos los espectadores. ¿Estás seguro?",
    "endReadyConfirm": "Esto finalizará el evento en vivo para que ya no sea visible para los espectadores. ¿Estás seguro?"
  },
  "broadcast": {
    "webOnly": "Las sesiones en vivo solo están disponibles en la web",
    "inProgress": "Sesión en Vivo en Progreso",
    "leaveConfirm": "Tu sesión en vivo está en curso. Salir de esta página la finalizará. ¿Estás seguro?",
    "stay": "Quedarse",
    "endAndLeave": "Finalizar y Salir",
    "studio": "ESTUDIO",
    "dashboard": "Panel de Control",
    "preparing": "Preparando estudio...",
    "readyTitle": "Listo para la Sesión en Vivo",
    "readyHint": "La cámara se activará cuando comience la sesión en vivo",
    "connectingStream": "Conectando a la sesión en vivo...",
    "complete": "Sesión en Vivo Finalizada",
    "savedHint": "Sesión guardada exitosamente",
    "connectionError": "Error de conexión",
    "sessionDetails": "DETALLES DE LA SESIÓN",
    "titleLabel": "Título",
    "scheduledLabel": "Programado",
    "durationLabel": "Duración",
    "goLive": "INICIAR SESIÓN EN VIVO",
    "backToDashboard": "VOLVER AL PANEL",
    "cancelEvent": "Cancelar Evento",
    "nowStreaming": "LIVE",
    "liveSessionDefault": "Sesión en vivo",
    "rec": "REC",
    "endStreamBtn": "FINALIZAR SESIÓN EN VIVO",
    "muted": "Silenciado",
    "audioOn": "Audio Activado",
    "cameraOff": "Cámara Apagada",
    "videoOn": "Video Activado",
    "endFailed": "Error al finalizar el en vivo: {{error}}"
  },
  "share": {
    "subject": "Únete a la sesión en vivo «{{title}}» en Agapella",
    "message": "Únete a la sesión en vivo «{{title}}» en Agapella\n{{url}}"
  },
  "guest": {
    "webOnlyTitle": "La sesión en vivo de invitado solo está disponible en el navegador",
    "webOnlyBody": "Abre el enlace en una computadora para unirte con micrófono y cámara.",
    "limitReachedTitle": "Asientos llenos",
    "limitReachedBody": "Todos los asientos de invitados de esta sesión en vivo están ocupados. Puedes unirte como espectador — verás y escucharás a todos los oradores y podrás chatear.",
    "watchAsViewer": "Mirar como espectador",
    "openRecording": "Abrir grabación",
    "expiredTitle": "Este enlace ya no es válido",
    "expiredBody": "Este enlace fue revocado o ha expirado. Pide al anfitrión un enlace nuevo.",
    "notStartedTitle": "La sesión en vivo aún no ha comenzado",
    "notStartedBody": "El anfitrión aún no ha abierto la sesión en vivo. Actualiza en un minuto o espera la invitación.",
    "connectFailedTitle": "No se pudo conectar",
    "media": {
      "retry": "Reintentar",
      "system_blockedTitle": "El sistema bloqueó la cámara",
      "system_blockedBody": "El navegador tiene acceso, el sistema operativo no. En Mac: Configuración del Sistema → Privacidad y seguridad → Cámara y Micrófono, activa tu navegador y reinícialo. En Windows: Configuración → Privacidad → Cámara y Micrófono. Después vuelve aquí y pulsa «Reintentar».",
      "deniedTitle": "Sin acceso a la cámara y el micrófono",
      "deniedBody": "El navegador no nos dejó acceder a la cámara. Pulsa el candado junto a la dirección de la página, permite cámara y micrófono, y vuelve a «Reintentar».",
      "not_foundTitle": "No se encontró cámara ni micrófono",
      "not_foundBody": "No vemos ninguna cámara ni micrófono. Conecta un dispositivo y pulsa «Reintentar». Si la cámara es integrada, comprueba que no esté desactivada en el sistema.",
      "in_useTitle": "Otra aplicación está usando la cámara",
      "in_useBody": "Parece que la cámara ya está en uso en otra pestaña o aplicación, por ejemplo una videollamada. Ciérrala y pulsa «Reintentar»."
    },
    "masterDisconnectedTitle": "El anfitrión se desconectó",
    "masterDisconnectedBody": "Se perdió la conexión con el anfitrión. Esperando unos segundos — si vuelve, la sesión en vivo continúa.",
    "streamEndedTitle": "Sesión en vivo finalizada",
    "streamEndedBody": "El anfitrión finalizó la sesión en vivo. Gracias por estar aquí. La grabación y la información del evento están en la página de la sesión en vivo."
  },
  "wizard": {
    "audioCategory": {
      "All": "Todas",
      "Ambient": "Ambiental",
      "BinauralBeats": "Ritmos binaurales",
      "NatureSounds": "Sonidos de la naturaleza",
      "Mantra": "Mantras",
      "TibetanBowls": "Cuencos tibetanos",
      "WhiteNoise": "Ruido blanco",
      "Other": "Otros"
    },
    "libraryCount": {
      "shown": "Mostrando {{shown}} de {{total}}",
      "partial": "Mostrando {{shown}} · la biblioteca no se cargó por completo ({{loaded}} de {{total}})"
    },
    "libraryEmpty": {
      "noResults": "No se encontraron resultados para tu búsqueda",
      "clearSearch": "Borrar búsqueda"
    }
  },
  "native": {
    "subtitle": "Tu camino de práctica y encuentros",
    "calendarOverline": "ESTILO DE VIDA",
    "eventsOn": "Eventos del {{date}}",
    "eventsOnDay": "Eventos del",
    "allEvents": "Todos los eventos",
    "noEventsThisDay": "No hay eventos este día",
    "noUpcoming": "No hay eventos próximos",
    "whatsNext": "Qué viene después",
    "nothingPlanned": "Todavía no hay nada planeado",
    "legend": {
      "online": "Online",
      "offline": "Presencial",
      "recordings": "Grabaciones"
    },
    "filters": {
      "directions": "Direcciones",
      "directionsCount": "Direcciones ({{count}})",
      "liveSessions": "Sesiones en vivo",
      "offline": "Presencial",
      "livePractices": "Prácticas en vivo",
      "allDirections": "Todas las direcciones"
    },
    "pickMonth": "Elige un mes",
    "pickMonthA11y": "Elegir mes",
    "done": "Listo",
    "collections": {
      "title": "Colecciones",
      "seeAll": "Ver todo ›"
    },
    "card": {
      "event": "Evento",
      "minutes": "min",
      "master": "Maestro",
      "yours": "Tu sesión en vivo",
      "going": "Voy",
      "join": "Unirse",
      "offline": "PRESENCIAL",
      "online": "ONLINE",
      "open": "Abrir"
    },
    "signInToJoin": "Inicia sesión para apuntarte al evento",
    "gridWeekdays": [
      "L",
      "M",
      "X",
      "J",
      "V",
      "S",
      "D"
    ]
  }
}
